export enum FamousPeopleView {
  DASHBOARD = 1,
  CREATE = 2,
  EDIT = 3,
}
